const strings = {
  buttons: {
    clear: 'Limpar',
    send: 'Pesquisar',
  },
}

export default strings
